/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .json-editor-toolbar {
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 10;
  }

  .json-editor-container {
    position: relative;
    width: 100%;
    z-index: 9;
  }

  .json-editor-container :where(.cm-editor) {
    height: 100%;
    overflow: auto;
  }
`;
